import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import Nav from "@/components/Nav";
import { ArrowRight } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setErr("");
    const r = await login(email, password);
    setSubmitting(false);
    if (!r.ok) {
      setErr(r.error);
      return;
    }
    if (r.user.role === "admin") nav("/admin");
    else nav("/dashboard");
  };

  return (
    <div data-testid="login-page">
      <Nav theme="dark" />
      <div className="sv-auth">
        <div className="starfield" />
        <form className="sv-auth-card" onSubmit={onSubmit}>
          <span className="eyebrow">Doctor & Admin access</span>
          <h1 style={{ marginTop: 14 }}>Welcome <span className="em-shimmer">back.</span></h1>
          <p className="sub">Sign in to see your assigned sleep studies in real-time.</p>
          <label className="sv-label" style={{ color: "rgba(255,255,255,0.7)" }}>Email</label>
          <input
            className="sv-auth-input"
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="dr.yourname@somveil.in"
            required
            data-testid="login-email-input"
          />
          <label className="sv-label" style={{ color: "rgba(255,255,255,0.7)" }}>Password</label>
          <input
            className="sv-auth-input"
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            placeholder="••••••••"
            required
            data-testid="login-password-input"
          />
          {err && <p className="sv-err" data-testid="login-error">{err}</p>}
          <button
            type="submit"
            disabled={submitting}
            className="btn btn-primary"
            style={{ width: "100%", marginTop: 8, justifyContent: "center" }}
            data-testid="login-submit-btn"
          >
            {submitting ? "Signing in..." : "Sign in"} <ArrowRight size={16} />
          </button>
          <div style={{ marginTop: 24, fontSize: 12, color: "rgba(255,255,255,0.5)", textAlign: "center" }}>
            Not a doctor on the platform? <Link to="/" style={{ color: "var(--mint)" }}>Return home</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
